export default __webpack_public_path__ + "assets/dasa-logo-component.5113b45f.svg";